import {
    Box,
    MenuItem,
    Select,
    Skeleton,
    useTheme
} from "@mui/material";
import { CustomDropdownBlueIcon } from "../../../../assets/SvgIcons";
import {
    CustomDropdownProps,
    DropdownOption
} from "../types";

export default function CustomDropdown({
    isLoading,
    selectedValue,
    handleValueChange,
    dropdownOptions,
    ariaLabel = 'Filter selection'
}: CustomDropdownProps): JSX.Element {
    const theme = useTheme()

    return (
        <>
            {isLoading && (
                <Skeleton
                    animation='wave'
                    width={200}
                    height={30}
                    aria-label={`Loading ${ariaLabel}`}
                />
            )}
            {!isLoading && (
                <Box>
                    <Select
                        value={selectedValue}
                        onChange={handleValueChange}
                        aria-label={ariaLabel}
                        inputProps={{ 'aria-label': ariaLabel }}
                        sx={{
                            ...theme.typography.body_500,
                            color: theme.palette.primary[500],
                            fontFamily: theme.typography.fontFamily,
                            cursor: 'pointer',
                            padding: "7px 5px",
                            textTransform: "capitalize",
                            "& .MuiSelect-outlined": {
                                padding: "0px 7px",
                            },
                            "& .MuiSelect-select.MuiSelect-outlined.MuiInputBase-input.MuiOutlinedInput-input": {
                                paddingRight: "20px",
                            },
                            "&.Mui-focused": {
                                backgroundColor: `${theme.palette.primary[50]}`,
                                outline: `2px solid ${theme.palette.primary[500]}`,
                                outlineOffset: '2px',
                                borderRadius: '4px',
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderWidth: "0",
                                    borderBottom: `1px dashed ${theme.palette.text.secondary}`,
                                },
                            },
                            "& .MuiOutlinedInput-notchedOutline": {
                                borderTop: 0,
                                borderLeft: 0,
                                borderRight: 0,
                                marginBottom: 0,
                                borderBottom: `1px dashed ${theme.palette.text.secondary}`,
                                borderRadius: 0,
                            },
                        }}
                        IconComponent={CustomDropdownBlueIcon}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    padding: "0px 5px",
                                    borderRadius: "12px",
                                    "& .MuiMenuItem-root": {
                                        padding: "6px",
                                        borderRadius: "8px",
                                        ...theme.typography.body_500,
                                        fontFamily: theme.typography.fontFamily,
                                        color: theme.palette.primary[500],
                                        my: 0.4,
                                        "&.Mui-selected": {
                                            backgroundColor: theme.palette.primary[500],
                                            color: theme.palette.common.white,
                                        },
                                        "&.Mui-focusVisible": {
                                            backgroundColor: 'transparent',
                                            color: theme.palette.primary[500],
                                            outline: `2px solid ${theme.palette.primary[500]}`,
                                            outlineOffset: '-2px',
                                        },
                                        "&.Mui-selected.Mui-focusVisible": {
                                            backgroundColor: theme.palette.primary[50],
                                        },
                                    },
                                    "& .MuiMenuItem-root:hover": {
                                        backgroundColor: theme.palette.primary[50],
                                        color: theme.palette.primary[500],
                                    },
                                },
                            },
                        }}
                    >
                        {dropdownOptions.map((data: DropdownOption, key: number) => (
                            <MenuItem
                                key={key}
                                value={data.value}
                                sx={{
                                    textTransform: "capitalize",
                                }}
                            >
                                {data?.label?.toLowerCase()}
                            </MenuItem>
                        ))}
                    </Select>
                </Box >
            )
            }
        </>
    )
}